"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableMulticheckBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("./bc-data-table-constants");
var bc_data_table_header_paginator_behavior_1 = require("./bc-data-table-headers/bc-data-table-header-paginator-behavior");
var bc_data_table_header_selection_behavior_1 = require("./bc-data-table-headers/bc-data-table-header-selection-behavior");
var BcDataTableMulticheckBehavior = (function () {
    function BcDataTableMulticheckBehavior(config) {
        this.config = config;
        this.bcDataTableConfig = config;
        this.bcDataTable = document.getElementById(this.bcDataTableConfig.id);
        this.bcDataTableHeaderPaginatorBehavior = new bc_data_table_header_paginator_behavior_1.BcDataTableHeaderPaginatorBehavior(this.bcDataTableConfig);
        this.bcDataTableHeaderSelectionBehavior = new bc_data_table_header_selection_behavior_1.BcDataTableHeaderSelectionBehavior(this.bcDataTableConfig);
    }
    BcDataTableMulticheckBehavior.prototype.reset = function () {
        this.bcDataTableConfig.data.forEach(function (subArray) {
            var checkObject = subArray.find(function (obj) { return obj.type === 'check'; });
            if (checkObject) {
                checkObject.value = false;
            }
        });
    };
    BcDataTableMulticheckBehavior.prototype.getTheadCheckbox = function () {
        var checkboxElement = this.getCheckbox();
        var inputCheckbox = checkboxElement.querySelector(common_constants_1.BcCommonConstants.INPUT_CHECKBOX_TAG);
        inputCheckbox.addEventListener(common_constants_1.BcCommonConstants.EVENT_CHANGE, this.handleTheadCheckboxChange.bind(this));
        return checkboxElement;
    };
    BcDataTableMulticheckBehavior.prototype.getTbodyCheckbox = function () {
        var checkboxElement = this.getCheckbox();
        var inputCheckbox = checkboxElement.querySelector(common_constants_1.BcCommonConstants.INPUT_CHECKBOX_TAG);
        inputCheckbox.addEventListener(common_constants_1.BcCommonConstants.EVENT_CHANGE, this.handleBodyCheckboxChange.bind(this));
        return checkboxElement;
    };
    BcDataTableMulticheckBehavior.prototype.getCheckbox = function () {
        var labelElement = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        labelElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_CONTAINER_CLASS);
        var checkboxElement = document.createElement(common_constants_1.BcCommonConstants.INPUT_TAG);
        checkboxElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTRIBUTE_TYPE, bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_TEXT);
        var spanElement = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        spanElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_CLASS);
        labelElement.appendChild(checkboxElement);
        labelElement.appendChild(spanElement);
        return labelElement;
    };
    BcDataTableMulticheckBehavior.prototype.findIndexById = function (array, id) {
        for (var i = 0; i < array.length; i++) {
            var innerArray = array[i];
            var idObject = innerArray.find(function (obj) { return obj.type === 'id'; });
            if (idObject && idObject.value === id) {
                return i;
            }
        }
        return -1;
    };
    BcDataTableMulticheckBehavior.prototype.handleBodyCheckboxChange = function (event) {
        var clickedCheckbox = event.target;
        var trCheckboxContainer = clickedCheckbox.closest(common_constants_1.BcCommonConstants.TR_TAG);
        var objectId = parseInt(trCheckboxContainer.getAttribute(bc_data_table_constants_1.BcDataTableConstansts.ROW_ID));
        var rowIndexCheckboxClicked = this.findIndexById(this.bcDataTableConfig.data, objectId);
        var checkObject = __assign({}, this.bcDataTableConfig.data[rowIndexCheckboxClicked][0]);
        checkObject.value = clickedCheckbox.checked;
        this.bcDataTableConfig.data[rowIndexCheckboxClicked][0] = checkObject;
        if (clickedCheckbox.checked) {
            trCheckboxContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TR_SELECTED_CLASS);
        }
        else {
            trCheckboxContainer.classList.remove(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TR_SELECTED_CLASS);
        }
        this.checkIfAllCheckboxAreChecked(clickedCheckbox);
        this.bcDataTableHeaderSelectionBehavior.checkState(this.bcDataTable);
    };
    BcDataTableMulticheckBehavior.prototype.handleTheadCheckboxChange = function (event) {
        var clickedCheckbox = event.target;
        var datatable = clickedCheckbox.closest(common_constants_1.BcCommonConstants.TABLE_TAG);
        this.bcDataTableConfig.data.forEach(function (value, index) {
            var checkObject = value[0];
            checkObject.value = clickedCheckbox.checked;
            value[0] = checkObject;
        });
        var tbody = datatable.querySelector(common_constants_1.BcCommonConstants.TBODY_TAG);
        var trRows = Array.from(tbody.querySelectorAll(common_constants_1.BcCommonConstants.TR_TAG));
        trRows.forEach(function (trRow) {
            var inputCheckbox = trRow.querySelector(common_constants_1.BcCommonConstants.INPUT_CHECKBOX_TAG);
            inputCheckbox.checked = clickedCheckbox.checked;
            if (clickedCheckbox.checked) {
                trRow.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TR_SELECTED_CLASS);
            }
            else {
                trRow.classList.remove(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TR_SELECTED_CLASS);
            }
        });
        this.bcDataTableHeaderSelectionBehavior.checkState(this.bcDataTable);
    };
    BcDataTableMulticheckBehavior.prototype.checkIfAllCheckboxAreChecked = function (clickedCheckbox) {
        var _a;
        var data = this.bcDataTableConfig.data;
        if ((_a = this.bcDataTableConfig.header) === null || _a === void 0 ? void 0 : _a.paginator) {
            data = this.bcDataTableHeaderPaginatorBehavior.getPaginatedArray(this.bcDataTableConfig.data);
        }
        var table = clickedCheckbox.closest(common_constants_1.BcCommonConstants.TABLE_TAG);
        var thead = table.querySelector(common_constants_1.BcCommonConstants.THEAD_TAG);
        var checkAllCheckbox = thead.querySelector(common_constants_1.BcCommonConstants.INPUT_CHECKBOX_TAG);
        var rowCheckeds = data.filter(function (row) { return row[0].value === true; });
        if (rowCheckeds.length === 0) {
            checkAllCheckbox.checked = false;
            checkAllCheckbox.indeterminate = false;
        }
        else if (rowCheckeds.length === data.length) {
            checkAllCheckbox.checked = true;
            checkAllCheckbox.indeterminate = false;
        }
        else {
            checkAllCheckbox.indeterminate = true;
        }
    };
    return BcDataTableMulticheckBehavior;
}());
exports.BcDataTableMulticheckBehavior = BcDataTableMulticheckBehavior;
